"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfOrientationMatchDto = instanceOfOrientationMatchDto;
exports.OrientationMatchDtoFromJSON = OrientationMatchDtoFromJSON;
exports.OrientationMatchDtoFromJSONTyped = OrientationMatchDtoFromJSONTyped;
exports.OrientationMatchDtoToJSON = OrientationMatchDtoToJSON;
exports.OrientationMatchDtoToJSONTyped = OrientationMatchDtoToJSONTyped;
const ShiftMatchProfileDto_1 = require("./ShiftMatchProfileDto");
const ShiftRequestStatus_1 = require("./ShiftRequestStatus");
/**
 * Check if a given object implements the OrientationMatchDto interface.
 */
function instanceOfOrientationMatchDto(value) {
    if (!('nurseProfile' in value) || value['nurseProfile'] === undefined)
        return false;
    if (!('requestStatus' in value) || value['requestStatus'] === undefined)
        return false;
    return true;
}
function OrientationMatchDtoFromJSON(json) {
    return OrientationMatchDtoFromJSONTyped(json, false);
}
function OrientationMatchDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'nurseProfile': (0, ShiftMatchProfileDto_1.ShiftMatchProfileDtoFromJSON)(json['nurseProfile']),
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusFromJSON)(json['requestStatus']),
        'requestedByProfile': json['requestedByProfile'] == null ? undefined : json['requestedByProfile'],
        'isQualifiedForStipend': json['isQualifiedForStipend'] == null ? undefined : json['isQualifiedForStipend'],
        'requestUpdatedAt': json['requestUpdatedAt'] == null ? undefined : (new Date(json['requestUpdatedAt'])),
    };
}
function OrientationMatchDtoToJSON(json) {
    return OrientationMatchDtoToJSONTyped(json, false);
}
function OrientationMatchDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'nurseProfile': (0, ShiftMatchProfileDto_1.ShiftMatchProfileDtoToJSON)(value['nurseProfile']),
        'requestStatus': (0, ShiftRequestStatus_1.ShiftRequestStatusToJSON)(value['requestStatus']),
        'requestedByProfile': value['requestedByProfile'],
        'isQualifiedForStipend': value['isQualifiedForStipend'],
        'requestUpdatedAt': value['requestUpdatedAt'] == null ? undefined : ((value['requestUpdatedAt']).toISOString()),
    };
}
//# sourceMappingURL=OrientationMatchDto.js.map